angular.module('TetherApp').controller('SurveyController', [
    '$q',
    '$anchorScroll',
    '$location',
    '$window',
    '$timeout',
    '$mdDialog',
    '$mdToast',
    'surveyService',
    'modelLockService',
    '$interval',
    function (
        $q,
        $anchorScroll,
        $location,
        $window,
        $timeout,
        $mdDialog,
        $mdToast,
        surveyService,
        modelLockService,
        $interval
    ) {

        let self = this;
        let redirectTo = '/experience/survey';

        self.isSubmitting = false;

        self.survey = {
            logo: '',
            javascript: '',
            html: '',
            form: {fields: {}}
        };
        self.dropdown = {};
        self.fieldCount = [];
        self.currentFieldIndex = 0;
        self.currentOptionIndex = {};
        self.currentType = 'label';
        self.controlTypes = {
            label: 'Label' ,
            text: 'Text',
            textarea: 'Textarea',
            select: 'Select',
            ranking: 'Ranking',
            checkbox: 'Checkbox',
            radio: 'Radio',
            section: 'Section'
        };

        //Model Lock
        self.modelLock;
        self.experienceLockTimeRemainingDisplay;
        self.experienceLockTimeEndDisplay;
        self.experienceLockCountdown = undefined;

        //START: CUSTOM
        let getControlDefaults = function (type, index) {
            let inputObjects = {
                label: {
                    json_id: index,
                    type: 'label',
                    order_id: index,
                    text: '',
                    name: ''
                },
                text: {
                    json_id: index,
                    type: 'text',
                    order_id: index,
                    placeholder: '',
                    default_value: '',
                    name: ''
                },
                textarea: {
                    json_id: index,
                    type: 'textarea',
                    order_id: index,
                    placeholder: '',
                    name: ''
                },
                select: {
                    json_id: index,
                    type: 'select',
                    order_id: index,
                    name: '',
                    options: {
                        1: {
                            json_id: 1,
                            text: '',
                            value: ''
                        }
                    }
                },
                ranking: {
                    json_id: index,
                    type: 'ranking',
                    order_id: index,
                    is_ordered: true,
                    name: '',
                    options: {
                        1: {
                            json_id: 1,
                            text: '',
                            value: '',
                            name: ''
                        }
                    }
                },
                checkbox: {
                    json_id: index,
                    type: 'checkbox',
                    order_id: index,
                    text: '',
                    value: '',
                    name: ''
                },
                radio: {
                    json_id: index,
                    type: 'radio',
                    order_id: index,
                    text: '',
                    value: '',
                    name: ''
                },
                section: {
                    json_id: index,
                    type: 'section',
                    order_id: index,
                    text: '',
                    name: ''
                }
            };

            if (inputObjects.hasOwnProperty(type)) {
                return inputObjects[type];
            } else {
                return {};
            }
        };

        self.addField = function () {
            let count = (Object.keys(self.survey.form.fields).length + 1);
            for (let idx in self.survey.form.fields) {
                while (self.survey.form.fields[idx]['json_id'] == count
                || self.survey.form.fields[idx]['order_id'] == count) {
                    count += 1;
                }
            }
            let name = 'Field ' + count;
            let form_name = 'field_' + count;
            self.survey.form.fields[count] = {
                json_id: count,
                name : name,
                form_name : form_name,
                order_id: count,
                controls: {}
            };
        };

        self.addControl = function () {
            let count = (Object.keys(self.survey.form.fields[self.currentFieldIndex].controls).length + 1);
            for (let idx in self.survey.form.fields[self.currentFieldIndex].controls) {
                while (self.survey.form.fields[self.currentFieldIndex].controls[idx]['json_id'] == count
                || self.survey.form.fields[self.currentFieldIndex].controls[idx]['order_id'] == count) {
                    count += 1;
                }
            }

            let tempObject = getControlDefaults(self.currentType, count);
            if (self.survey.form.fields[self.currentFieldIndex].controls.constructor === Array) {
                self.survey.form.fields[self.currentFieldIndex].controls.push(tempObject);
            } else {
                self.survey.form.fields[self.currentFieldIndex].controls[Object.keys(self.survey.form.fields[self.currentFieldIndex].controls).length + 1] = tempObject;
            }

            if (self.currentType == 'select' || self.currentType == 'ranking') {
                self.currentOptionIndex[self.currentFieldIndex] = 1;
            }

            self.updateControlTypes();
        };

        self.removeControl = function (index) {
            delete self.survey
                .form
                .fields[self.currentFieldIndex]
                .controls[index];

            self.updateControlTypes();
        };

        self.hasSection = function () {
            let hasSection = false;

            let controls = self.survey
                .form
                .fields[self.currentFieldIndex]
                .controls;

            for (let index in controls) {
                if (controls[index].type === 'section') {
                    hasSection = true;
                }
            }

            return hasSection;
        };

        self.addOption = function (index) {
            // let count = (Object.keys(self.survey.form.fields[self.currentFieldIndex].controls).length + 1);
            let count = self.currentOptionIndex[self.currentFieldIndex] + 1;
            self.currentOptionIndex[self.currentFieldIndex] = count;
            for (let idx in self.survey.form.fields[self.currentFieldIndex].controls[index]['options']) {
                while (self.survey.form.fields[self.currentFieldIndex].controls[index]['options'][idx]['json_id'] == count
                || self.survey.form.fields[self.currentFieldIndex].controls[index]['options'][idx]['order_id'] == count) {
                    count += 1;
                }
            }
            let tempObject = {
                json_id: count,
                text: '',
                value: '',
                name: ''
            };
            if (typeof self.survey.form.fields[self.currentFieldIndex].controls[index]['options'] == 'object') {
                self.survey.form.fields[self.currentFieldIndex].controls[index]['options'][count] = tempObject;
            } else {
                self.survey.form.fields[self.currentFieldIndex].controls[index]['options'].push(tempObject);
            }
        };

        self.removeOption = function (index, optionIndex) {
            delete self.survey.form.fields[self.currentFieldIndex].controls[index]['options'][optionIndex];
        };

        self.isEditingHtml = function (fieldIndex) {
            if (self.dropdown[fieldIndex] === undefined) {
                self.dropdown[fieldIndex] = true;
            } else {
                self.dropdown[fieldIndex] = !self.dropdown[fieldIndex];
            }
        };

        let DialogController = function ($mdDialog) {
            let dCtrl = this;
            dCtrl.parent = self;

            dCtrl.hide = function () {
                $mdDialog.hide();
            };

            dCtrl.cancel = function () {
                $mdDialog.cancel();
            };
        };

        self.updateControlTypes = function () {
            self.controlTypes = {
                label: 'Label',
                text: 'Text',
                textarea: 'Textarea',
                select: 'Select',
                ranking: 'Ranking',
                checkbox: 'Checkbox',
                radio: 'Radio',
                section: 'Section'
            };

            let currentControls = self.survey.form
                .fields[self.currentFieldIndex]
                .controls;

            for (let index in currentControls) {
                if (currentControls[index].type !== 'section') {
                    delete self.controlTypes.section;
                }
            }
        };

        self.configureModal = function(ev, fieldIndex) {
            self.currentFieldIndex = fieldIndex;
            self.currentType = 'label';
            self.updateControlTypes();
            DialogController.$inject = ['$mdDialog'];
            console.log(ev);
            $mdDialog.show({
                controller: DialogController,
                controllerAs: 'configureController',
                bindToController: true,
                templateUrl: '/experience/survey/partials/configure-modal',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };

        self.updateFieldPropertyName = function () {
            let tempName = self.survey.form.fields[self.currentFieldIndex].name;
            tempName = tempName.toLowerCase().replace(/ /g,'_');
            self.survey.form.fields[self.currentFieldIndex].form_name = tempName;
        };

        self.deleteField = function (fieldIndex, name) {
            let deleteText = 'Are you sure you want to delete field ' + name + '?';
            if ($window.confirm(deleteText)) {
                delete self.survey.form.fields[fieldIndex];
            }
        };
        //END: CUSTOM

        self.index = function (page) {
            self.currentPage = page;
            surveyService.indexSurvey(self.currentPage)
                .then(onIndex, onError);
        };

        let onIndex = function (data) {
            self.surveyList = data.data;
        };

        self.perPageChanged = function () {
            let form = window.document.querySelector('form#query_form');
            if (form) {
                $timeout(function () {
                    form.submit();
                });
            }
        };

        //START: SHOW SERVICE FUNCTIONS
        self.show = function (data) {
            self.survey = JSON.parse(JSON.stringify(data));
            self.fieldCount = range(1, Object.keys(self.survey.form.fields).length);
            self.getExperienceLock()
        };
        //END: SHOW SERVICE FUNCTIONS

        //START: STORE SERVICE FUNCTIONS
        self.store = function () {
            self.isSubmitting = true;
            surveyService.storeSurvey(self.survey)
                .then(onStore, onError);
        };

        let onStore = function (data) {
            redirectToIndex();
        };
        //END: STORE SERVICE FUNCTIONS

        //START: UPDATE SERVICE FUNCTIONS
        self.update = function () {
            let tempSurvey = self.survey;

            self.isSubmitting = true;
            surveyService.updateSurvey(tempSurvey)
                .then(onUpdate, onError);
        };

        let onUpdate = function (data) {
            self.releaseExperienceLock();
            redirectToIndex();
        };
        //END: UPDATE SERVICE FUNCTIONS

        //START: DESTROY SERVICE FUNCTIONS
        self.delete = function (surveyId) {
            if ($window.confirm(self.deleteText.replace(':id', surveyId))) {
                surveyService.deleteSurvey(surveyId)
                    .then(onDelete, onError);
            }
        };

        let onDelete = function (data) {
            redirectToIndex();
        };
        //END: DESTROY SERVICE FUNCTIONS

        //START: REPORT FUNCTIONS
        self.reportRegenerate = function (clientEid, experienceEid) {
            surveyService.reportRegenerate(clientEid, experienceEid)
                .then(onReportRegenerate, onError);
        };

        let onReportRegenerate = function () {
            $mdToast.show({
                hideDelay   : 2500,
                position    : 'bottom left',
                template : '<md-toast style="max-width: 425px">' +
                    '<span class="md-toast-text" flex><i style="color:green; margin-right: 8px;" class="fa fa-check" aria-hidden="true"></i>Successfully regenerated report</span>' +
                    '</md-toast>'
            });
        };
        //END: REPORT FUNCTIONS

        //START: GENERAL SERVICE FUNCTIONS
        let onError = function (data) {
            self.isSubmitting = false;
            $location.hash('top');
            $anchorScroll();
            self.errors = data.data.errors;
        };

        let redirectToIndex = function () {
            $window.location.href = '/' + self.client_eid + redirectTo;
        };
        //END: GENERAL SERVICE FUNCTIONS

        //START: REPORTING SECTION

        self.graph = {};
        self.start = undefined;
        self.end = undefined;

        self.isQuestionOpen = {};

        self.chartOptions = {
            scales: {
                xAxes: [{
                    ticks: {
                        beginAtZero: true,
                        callback: function(value) {if (value % 1 === 0) {return value;}}
                    }
                }],
                yAxes: [{
                    barThickness: 30
                }]
            }
        };

        self.loadStats = function (surveyId) {
            self.isLoading = true;
            if (self.currentId == undefined) {
                self.currentId = surveyId;
            }

            let tempStart = self.start ? self.start.toISOString() : null;
            let tempEnd = self.end ? self.end.toISOString() : null;

            let statsPromise = surveyService.getReport(
                self.currentId,
                {
                    start: tempStart,
                    end: tempEnd,
                    report_name: 'stats',
                    report_type: 'json'
                }
            ).then(onStats, onError);

            let graphPromise = surveyService.getReport(
                self.currentId,
                {
                    start: tempStart,
                    end: tempEnd,
                    report_name: 'graph',
                    report_type: 'json'
                }
            ).then(onGraph, onError);

            let summaryPromise = surveyService.getReport(
                self.currentId,
                {
                    start: tempStart,
                    end: tempEnd,
                    report_name: 'summary',
                    report_type: 'json'
                }
            ).then(onSummary, onError);

            $q.all([statsPromise, graphPromise, summaryPromise])
                .then(function () {
                    self.isLoading = false;
                });
        };

        self.updateStats = function () {
            self.loadStats();
            $mdToast.show({
                hideDelay : 1500,
                position : 'bottom left',
                template : '<md-toast>' +
                    '<span class="md-toast-text" flex><i style="color:green;" class="fa fa-check" aria-hidden="true"></i> Date range updated!</span>' +
                    '</md-toast>'
            });
        };

        let onSummary = function (data) {
            self.summary = [];

            angular.forEach(data.Questions, function(value, key) {
                let tempQuestion = {
                    question: value.Question,
                    series: ['Response Count'],
                    type: value.Type,
                    labels: [],
                    data: [[]],
                };

                responseCount = 0;

                for(let i in value["Answer Options"]) {
                    if (tempQuestion.type == 'text' || tempQuestion.type == 'textarea') {
                        responseCount += value["Answer Options"][i]["Response Count"];
                    } else {
                        tempQuestion.labels.push(i);
                        tempQuestion.data[0].push(value["Answer Options"][i]["Response Count"]);
                    }
                }

                if (tempQuestion.type == 'text' || tempQuestion.type == 'textarea') {
                    tempQuestion.labels.push('Responses');
                    tempQuestion.data[0].push(responseCount);
                }

                self.summary.push(tempQuestion);
            });
        };

        let onStats = function (data) {
            if (data.hasOwnProperty('dates') && data.dates.hasOwnProperty('start')) {
                self.start = new Date(data.dates.start);
            }
            if (data.hasOwnProperty('dates') && data.dates.hasOwnProperty('end')) {
                self.end = new Date(data.dates.end);
            }
            self.stats = {};
            self.stats = data;
        };

        let onGraph = function (data) {
            self.graph.data = data.data;
            self.graph.labels = data.labels;
            self.graph.series = data.series;
        };
        //END: REPORTING SECTION

        //START: MODALS
        self.dataPopup = function (ev, data) {
            self.data = JSON.parse(data);
            DialogController.$inject = ['$mdDialog'];
            $mdDialog.show({
                controller: DialogController,
                controllerAs: 'dataPopup',
                bindToController: true,
                templateUrl: '/experience/partials/data-pop-up',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                escapeToClose: true
            });
        };
        //END: MODALS

        //START: EXPERIENCE EDIT TIMER

        self.getExperienceLock = function() {
            let lockData = {
                'type': 'editing',
                'model_id': self.survey.experience.eid,
                'model_type': 'experience',
            };
            modelLockService.lock(lockData).then(initiateExperienceLock, onError);
        }

        self.extendExperienceLock = function() {
            let lockData = {
                'type': 'editing',
                'model_id': self.survey.experience.eid,
                'model_type': 'experience',
            };
            modelLockService.extend(lockData).then(initiateExperienceLock, onError);
        };

        self.releaseExperienceLock = function() {
            let lockData = {
                'type': 'editing',
                'model_id': self.survey.experience.eid,
                'model_type': 'experience',
            };
            modelLockService.release(lockData);
        };

        let initiateExperienceLock = function(modelLock) {
            self.modelLock = modelLock;
            self.experienceLockTimeEndDisplay = self.DisplayTime(modelLock.lock_expired_at);
            self.initiateExperienceLockCountdown(modelLock.seconds_left);
        };

        self.initiateExperienceLockCountdown = function (seconds) {
            let then = Date.now() + seconds * 1000;
            if (angular.isDefined(self.experienceLockCountdown)) {
                $interval.cancel(self.experienceLockCountdown);
                self.experienceLockCountdown = undefined
            }
            self.experienceLockCountdown = $interval(function () {
                let secondsLeft = Math.round((then - Date.now()) / 1000);
                if (secondsLeft < 0) {
                    self.experienceLockTimeRemainingDisplay = '0:00';
                    redirectToIndex();
                    $interval.cancel(self.experienceLockCountdown);
                } else {
                    let minutes = Math.floor(secondsLeft / 60);
                    let remainderSeconds = secondsLeft % 60;
                    self.experienceLockTimeRemainingDisplay = minutes + ':' + (remainderSeconds < 10 ? '0' : '') + remainderSeconds;
                    if (secondsLeft === 300) {
                        self.showExtendLock();
                    }
                }
            }, 1000);
        };

        self.DisplayTime = function(timestamp) {
            let end = new Date(timestamp);
            let hour = end.getHours();
            let adjustedHour = hour > 12 ? hour - 12 : hour;
            let minutes = end.getMinutes();
            return adjustedHour + ':' + (minutes < 10 ? '0' : '') + minutes;
        };

        self.showExtendLock = function() {
            var confirm = $mdDialog.confirm()
                    .title('Would you like to extend experience lock?')
                    .textContent('User will be redirected to index page without saving when timer runs out.')
                    .ariaLabel('Timer Dialog')
                    .ok('Extend Lock')
                    .cancel('Close');
            $mdDialog.show(confirm).then(function() {
                self.extendExperienceLock();
            }, function() {
                // this is close
            });
        };
        //END: EXPERIENCE EDIT TIMER
    }
]);
